import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["poster", "src", "autoplay", "loop", "muted", "controls", "onSetVideoRef"];
import React, { useEffect, useRef } from 'react';
var Video = function Video(_ref) {
  var poster = _ref.poster,
    src = _ref.src,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? true : _ref$muted,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? false : _ref$controls,
    onSetVideoRef = _ref.onSetVideoRef,
    rest = _objectWithoutProperties(_ref, _excluded);
  var videoRef = useRef(null);
  useEffect(function () {
    if (videoRef !== null && videoRef !== void 0 && videoRef.current && onSetVideoRef) {
      onSetVideoRef(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
    }
  }, [onSetVideoRef, videoRef]);
  if (!src) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/media-has-caption
    React.createElement("video", _extends({
      autoPlay: autoplay,
      controls: controls,
      loop: loop,
      muted: muted,
      poster: poster,
      ref: videoRef,
      src: src
    }, rest, {
      "data-t-id": "components-Media"
    }))
  );
};
export { Video };